import { render, staticRenderFns } from "./ClosingManager.vue?vue&type=template&id=1615c4f2&scoped=true"
import script from "./ClosingManager.vue?vue&type=script&lang=js"
export * from "./ClosingManager.vue?vue&type=script&lang=js"
import style0 from "./ClosingManager.vue?vue&type=style&index=0&id=1615c4f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1615c4f2",
  null
  
)

export default component.exports